var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { DropdownIndicatorBoxWrapper } from '../styles';
import styled from 'styled-components';
import arrow from '../../../images/inputs/arrow_dropdown.svg';
var ArrowSVG = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n"], ["\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n"])), arrow);
export var DropdownIndicatorBox = function (props) {
    return (React.createElement(DropdownIndicatorBoxWrapper, __assign({}, props.innerProps, { isActive: props.selectProps.menuIsOpen }),
        React.createElement(ArrowSVG, null)));
};
var templateObject_1;
//# sourceMappingURL=dropdownIndicatorBox.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { DropdownIndicatorBoxWrapper } from '../styles';
import styled from 'styled-components';
import arrow from '../../../images/inputs/arrow_dropdown.svg';
var ArrowSVG = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n"], ["\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n"])), arrow);
export var DropdownIndicatorBox = function (props) {
    return (React.createElement(DropdownIndicatorBoxWrapper, __assign({}, props.innerProps, { isActive: props.selectProps.menuIsOpen }),
        React.createElement(ArrowSVG, null)));
};
var templateObject_1;
//# sourceMappingURL=dropdownIndicatorBox.js.map